import analyze from "../../analyze/analyze";

const SoComEventNames = {
    sellerAddedToBag : "sellWithComCom",
    sellerAddedToCookie : "setCjeCookie",
    sellerRemovedFromBag : "removedSellerFromBag"
};

const SoComSellerAnalytics = (type, sellerId = null) => {

    const eventName = SoComEventNames?.[type];

    if(!eventName) throw new Error('Event type does not exist');

    analyze({
      name: eventName,
      props: {},
      data: {
        sellerId,
        url: window.location.href,
      },
    });
  };

export default SoComSellerAnalytics;

